/**
 * Joins class names, filtering out falsy values
 * Supports conditional classes via object syntax
 *
 * @example
 * joinClasses("foo", { bar: true }) // "foo bar"
 * joinClasses(["foo", "bar"], { baz: true }) // "foo bar baz"
 * joinClasses(["foo", { bar: true }]) // "foo bar"
 */
export function joinClasses(classes, conditionalClasses) {
    const classArray = [];
    // Normalize to array - wrap non-array inputs
    const classItems = Array.isArray(classes) ? classes : [classes];
    // Process main classes
    classItems.forEach((item) => {
        if (typeof item === "string") {
            classArray.push(item);
        }
        else if (Array.isArray(item)) {
            classArray.push(...item);
        }
        else if (typeof item === "object") {
            Object.entries(item).forEach(([key, value]) => {
                if (value) {
                    classArray.push(key);
                }
            });
        }
    });
    // Process conditional classes
    if (conditionalClasses) {
        Object.entries(conditionalClasses).forEach(([key, value]) => {
            if (value) {
                classArray.push(key);
            }
        });
    }
    return classArray.filter(Boolean).join(" ");
}
